import { useLocation } from "react-router-dom";
import orderStore from "@/stores/order.store";

// docket number takes from Location state if we have this data, on hard reload we are taking data from Store
const DynamicOrderDocketBreadcrumb = () => {
    const location = useLocation();
    return <span>{location?.state?.docketNumber ?? orderStore.selectedOrderDocketNumber}</span>;
};
export default DynamicOrderDocketBreadcrumb;
